import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg dark-themed",
  style: {"margin-bottom":"10%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "res/images/profile2.png",
  width: "30",
  height: "30",
  class: "d-inline-block align-top",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Vampire Studios ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav mr-auto" }
const _hoisted_7 = { class: "nav-item active" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_11 = {
  class: "dropdown-menu dark-themed",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_12 = {
  class: "dropdown-header",
  style: {"align-content":"center"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Randomly Adding Anything")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Hidden Gems")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Beyond Vanilla")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("StoryCraft")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Molecularcraft")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_20 = { class: "dropdown-header" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("VampireLib")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Customized Astral Body")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Spontaneous Bucketing")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Obsidian")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_27 = { class: "dropdown-header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Maewil")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Unnamed Cube Game")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Unnamed Unity Game")
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav-home')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav-about-the-team')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('nav-projects')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.$t('nav-category-minecraft-mods')), 1),
              _hoisted_13,
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/raa"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/hg"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/bv"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/sc"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/mc"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _hoisted_19,
              _createElementVNode("h6", _hoisted_20, _toDisplayString(_ctx.$t('nav-category-libraries')), 1),
              _hoisted_21,
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/vampirelib"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/cab"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/sb"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/obsidian"
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }),
              _hoisted_26,
              _createElementVNode("h6", _hoisted_27, _toDisplayString(_ctx.$t('nav-category-games')), 1),
              _hoisted_28,
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/mw"
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/uncg"
              }, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/project/unug"
              }, {
                default: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("li", _hoisted_32, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/translate"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav-translate')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_33, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav-contact-us')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_34, [
            _createElementVNode("h1", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLocale()))
            }, "Switch Language")
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}